import { render, staticRenderFns } from "./SizeChart.vue?vue&type=template&id=8c3044c4&scoped=true"
import script from "./SizeChart.vue?vue&type=script&lang=js"
export * from "./SizeChart.vue?vue&type=script&lang=js"
import style0 from "./SizeChart.vue?vue&type=style&index=0&id=8c3044c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3044c4",
  null
  
)

/* custom blocks */
import block0 from "./SizeChart.vue?vue&type=custom&index=0&blockType=any"
if (typeof block0 === 'function') block0(component)

export default component.exports